import { LoaderContext } from "container/MyProfile/Context/EditAndLoaderContext";
import { useContext } from "react";
import { Button } from "shared/Components/button";
import { OutlineButton } from "shared/Components/outlineButton";
export const SubmitButton = ({ handleCancel, handelSave, isLoading }) => {
  return (
    <div className="hidden md:flex lg:flex md:mr-[24px] lg:mr-20">
      <OutlineButton
        onClick={handleCancel}
        width={"w-44"}
        label={"Cancel Changes"}
      />
      <div className="ml-3" />
      <Button
        onClick={handelSave}
        width={"w-44"}
        label={"Save Changes"}
        disabled={isLoading}
      />
    </div>
  );
};
